import tokenHttpClient from "../utils/httpClient";
import { post } from "../utils/httpClient-methods";
import { PARTTYPE_API_URL, BASE_URL_MASTERS } from "../utils/AppApiUrl";

export const PartTypeListingService = async (requestBody) => {
  try {
    const vendorListingRequestObj = {
      active: requestBody?.active,
      pageNumber: requestBody?.pageNumber,
      pageSize: requestBody?.pageSize,
      //filterSearch: requestBody?.filterSearch ?? null,
      sortBy: requestBody?.sortBy,
      sortDirection: requestBody?.sortDirection,
      name: requestBody?.name ?? null,
      partCode: requestBody?.partCode ?? null,
    };
    const partTypeListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${PARTTYPE_API_URL.partTypeListing}`,
      vendorListingRequestObj
    );
    // add condition here to check
    if (partTypeListingResponse.status === 200) {
      return partTypeListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const partTypeListingSearchService = async (requestBody, searchValue) => {
  try {
    const partTypeListingRequestObj = {
      active: requestBody?.active,
      pageNumber: requestBody?.pageNumber,
      pageSize: requestBody?.pageSize,
      sortBy: requestBody?.sortBy,
      sortDirection: "ASC",
      name: searchValue ? searchValue : null,
      partCode: null
    };
    const partTypeListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${PARTTYPE_API_URL.partTypeListing}`,
      partTypeListingRequestObj
    );
    // add condition here to check
    if (partTypeListingResponse.status === 200) {
      return partTypeListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const typeChangeStatusService = async (requestBody) => {
  try {
    const typeStatusResponse = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${PARTTYPE_API_URL.typeChangeStatus}`,
      requestBody
    );
    // add condition here to check
    if (typeStatusResponse.status === 200) {
      return typeStatusResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const onAddTypeService = async (values) => {
  try {
    const requestBody = {
      sourceCode: values?.sourceCode ?? null,
      partTypeId: values?.partTypeId ?? "",
      origin: values?.origin ?? null,
      partTypeCode: values?.partTypeCode ?? "",
      name: values?.name ?? "",
      active: values && values.active === "false" ? false : true,
      createdOn: values?.createdOn,
      createdBy: values?.createdBy,
      modifiedOn: values?.modifiedOn,
      modifiedBy: values?.modifiedBy,
    };
    const saveTypeDetails = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${PARTTYPE_API_URL.savePartTypeDetails}`,
      requestBody
    );
    if (saveTypeDetails.status === 200) {
      return saveTypeDetails;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const onEditTypeService = async (values, typeId) => {
  try {
    const requestBody = {
      sourceCode: values?.sourceCode ?? null,
      partTypeId: typeId ?? "",
      origin: values?.origin ?? null,
      partTypeCode: values?.partTypeCode ?? "",
      name: values?.name ?? "",
      active: values?.active,
      createdOn: values?.createdOn,
      createdBy: values?.createdBy,
      modifiedOn: new Date(),
      modifiedBy: values?.modifiedBy,
    };
    const editTypeDetails = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${PARTTYPE_API_URL.editpartTypeDetails}`,
      requestBody
    );
    if (editTypeDetails.status === 200) {
      return editTypeDetails;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};
